<template>
  <v-app>
    <v-container>
      <div class="c-body">
        <main class="c-main">
          <v-container
            fluid
          >
            <v-row
              class="d-flex content-center text-left"
            >
              <v-col
                cols="12"
                lg="6"
              >
                <v-card
                  v-if="inviteRecord.appt_id === 0 || inviteRecord.appt_id === null"
                  class="px-4 py-2"
                >
                  <v-card-title>
                    <h2>Setup Appointment</h2>
                  </v-card-title>
                  <v-tabs
                    v-model="activeTab"
                  >
                    <v-tab>
                      <v-icon>
                        cil-calculator
                      </v-icon>
                      Verify
                    </v-tab>
                    <v-tab
                      :disabled="inviteVerified"
                    >
                      <v-icon name="cil-calculator">
                        cil-chart-pie
                      </v-icon>
                      Select
                    </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="activeTab">
                    <v-tab-item
                      ref="tabVerify"
                      class="pt-1"
                    >
                      <v-form>
                        <div>
                          <v-btn
                            block
                            color="primary"
                            @click="warningModal = true"
                          >
                            CLICK or TAP to VERIFY
                          </v-btn>
                        </div>
                        <v-row>
                          <v-col sm="12">
                            <v-text-field
                              v-model="inviteRecord.customer_name"
                              label="Name"
                              placeholder="Name goes here"
                              :readonly="true"
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                          >
                            <v-text-field
                              label="Address"
                              placeholder="Address goes here"
                              :value="inviteRecord.address_string"
                              :readonly="true"
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            tag="label"
                            cols="12"
                            class="col-form-label ml-3"
                          >
                            Please select your availability when finding an appointment
                          </v-col>
                          <v-col
                            cols="12"
                            class="ml-7 my-n8"
                          >
                            <v-checkbox
                              v-model="inviteRecord.bool_avail_am"
                              label="AM"
                              name="available_am"
                              :inline="true"
                              @update:checked="availChanged_am"
                            ></v-checkbox>
                            <v-checkbox
                              v-model="inviteRecord.bool_avail_pm"
                              label="PM"
                              :checked.sync="inviteRecord.bool_avail_pm"
                              name="available_pm"
                              :inline="true"
                              @update:checked="availChanged_pm"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col sm="6">
                            <v-text-field
                              v-model="inviteRecord.appt_description"
                              label="Appointment Type"
                              placeholder="Type"
                              :readonly="true"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="6">
                            <v-text-field
                              label="Duration"
                              :value="this.getDurationText"
                              :readonly="true"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row
                          class="my-n10"
                        >
                          <v-col>
                            <v-card>
                              <v-card-title>
                                Contact Details
                              </v-card-title>
                              <v-row
                                class="px-3"
                              >
                                <v-col sm="12">
                                  <v-text-field
                                    v-model="inviteRecord.customer_email"
                                    label="Email"
                                    placeholder="Contact email address"
                                    :readonly="true"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row
                                class="px-3"
                              >
                                <v-col sm="12">
                                  <v-text-field
                                    v-model="inviteRecord.customer_phone"
                                    label="Phone Number"
                                    placeholder="No number on file"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  v-if="inviteRecord.customer_sms !== ''"
                                  sm="12"
                                >
                                  <v-text-field
                                    v-model="inviteRecord.customer_sms"
                                    label="SMS Number"
                                    placeholder="No number on file"
                                  />
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                        <v-row
                          style="display: none"
                        >
                          <v-col sm="12">
                            <v-text-field
                              v-model="inviteRecord.customer_notes"
                              label="Feedback"
                              placeholder="Provide feedback or notes about the appointment."
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                      <GmapMap
                        class="mt-7"
                        sm="12"
                        :center="apptCoords"
                        :zoom="16"
                        map-type-id="terrain"
                        :style="mapStyleMd"
                      >
                        <GmapMarker
                          :position="apptCoords"
                        />
                      </GmapMap>
                      <div>
                        <v-btn
                          block
                          color="primary"
                          @click="warningModal = true"
                        >
                          CLICK or TAP to VERIFY
                        </v-btn>
                      </div>
                    </v-tab-item>
                    <v-tab-item
                      ref="tabSelect"
                      class="pt-1"
                    >
                      <v-alert
                        v-show="!inviteVerified"
                      >
                        Please verify your information on the previous step before proceeding!
                      </v-alert>
                      <vue-cal
                        v-show="inviteVerified"
                        style="height: 300px"
                        hide-weekends
                        :time="false"
                        active-view="month"
                        :disable-views="['years', 'year', 'week']"
                        :events="appointmentOptions"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @click-to-navigate="clickToNav"
                        @on-event-click="onEventClick"
                      >
                        <template v-slot:event="{ event }">
                          <v-icon>{{ event.icon }}</v-icon>

                          <div
                            class="vuecal__event-title"
                            v-html="event.title"
                          />
                          <div
                            class="py-3"
                          >
                            <v-btn
                              @click="onEventClick(event)"
                            >
                              Click to Schedule
                            </v-btn>
                          </div>
                          <!--                            <small class="vuecal__event-time">-->
                          <!--                              &lt;!&ndash; Using Vue Cal injected Date prototypes &ndash;&gt;-->
                          <!--                              <strong>Event start:</strong> <span>{{ event.start.formatTime("h O'clock") }}</span><br />-->
                          <!--                              <strong>Event end:</strong> <span>{{ event.end.formatTime("h O'clock") }}</span>-->
                          <!--                            </small>-->
                        </template>
                      </vue-cal>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
                <v-card v-else>
                  <div style="text-align: center">
                    <h1>Appointment Details</h1>
                  </div>
                  <div style="text-align: center">
                    <h4><p>Your appointment is currently scheduled for</p></h4>
                    <h3><p>{{ scheduledApptDateString }}</p></h3>
                    <h4><p>for the</p></h4>
                    <h3><p>{{ appointmentRecord.title }}</p></h3>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-dialog
            v-model="warningModal"
            title="Confirm Verification"
            color="warning"
            persistent
          >
            <v-card>
              <v-card-title>
                Verify Details
              </v-card-title>
              <div
                style="text-align: center"
              >
                By clicking confirm you have verified that the address and contact information provided is
                accurate and valid.
                </br>
                <template>
                  <v-btn
                    color="danger"
                    @click="warningModal = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="success"
                    @click="doVerify"
                  >
                    Confirm
                  </v-btn>
                </template>
              </div>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="confirmSelectionModal"
            title="Confirm Selection"
            color="warning"
            persistent
          >
            <v-card>
              <v-card-title>
                Confirm
              </v-card-title>
              <div style="text-align: center">
                <p>Are you sure you want accept the appointment on</p>
                <p style="font-weight: bold; font-style: oblique">
                  {{ this.apptDate }}
                </p>
                <p>for the </p>
                <p style="font-weight: bold; font-style: oblique">
                  {{ this.selectedEvent.title }} ?
                </p>
                <template>
                  <v-btn
                    color="danger"
                    @click="confirmSelectionModal = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="success"
                    :loading="processingAppt"
                    @click="doAcceptOption"
                  >
                    Confirm
                  </v-btn>
                </template>
              </div>
            </v-card>
            <v-overlay
              v-if="processingAppt"
              :opacity="0.8"
            />
          </v-dialog>
          <v-dialog
            v-model="errorGettingApptModal"
            title="Error"
            color="danger"
            persistent
          >
            <v-card>
              <div style="text-align: center">
                <p>There was a problem reserving your appointment. Please try again.</p>
              </div>
              <template slot="footer">
                <v-btn
                  color="success"
                  @click="errorGettingApptModal = false"
                >
                  Okay
                </v-btn>
              </template>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="successGettingApptModal"
            persistent
            title="Success"
            color="Success"
          >
            <v-card>
              <div style="text-align: center">
                <p>We successfully created your appointment!</p>
                <p style="font-weight: bold; font-style: oblique">
                  {{ this.apptDate }}
                </p>
                <p>for the </p>
                <p style="font-weight: bold; font-style: oblique">
                  {{ this.selectedEvent.title }}
                </p>
                <template>
                  <v-btn
                    color="success"
                    @click="successGettingApptModal = false"
                  >
                    Okay
                  </v-btn>
                </template>
              </div>
            </v-card>
          </v-dialog>
        </main>
      </div>
    </v-container>
  </v-app>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import moment from '../../assets/js/moment.min'
  import VueCal from 'vue-cal'
  import 'vue-cal/dist/vuecal.css'
  export default {
    name: 'Appointment',
    props: {
      apptID: {
        type: String,
        default: null,
      },
      secret: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        activeTab: 0,
        clickToNav: true,
        defaultStyle: {
          display: 'inline-block',
          width: '100%',
          height: '200px',
        },
        mapStyleSm: {
          display: 'inline-block',
          width: '100%',
          height: '200px',
        },
        mapStyleMd: {
          display: 'inline-block',
          width: '100%',
          height: '400px',
        },
        mapStyleLg: {
          display: 'inline-block',
          width: '100%',
          height: '600px',
        },
        tabs: [
          'Calculator',
          'Shopping cart',
          'Charts',
        ],
        warningModal: false,
        selectedEvent: {},
        confirmSelectionModal: false,
        processingAppt: false,
        errorGettingApptModal: false,
        successGettingApptModal: false,

      }
    },
    computed: {
      ...mapGetters(['inviteRecord', 'appointmentRecord', 'appointmentOptions', 'appointmentTypeOptions', 'appointmentDurationOptions', 'inviteVerified', 'appointmentSelected']),
      apptQS: function () {
        return this.apptID
      },
      secretQS: function () {
        return this.secret
      },
      apptCoords: function () {
        var latitude = typeof this.inviteRecord.address_lat !== 'undefined' ? this.inviteRecord.address_lat : 37.794603
        var longitude = typeof this.inviteRecord.address_lng !== 'undefined' ? this.inviteRecord.address_lng : -120.99223
        return { lat: latitude, lng: longitude }
      },
      getDurationText: function () {
        var duration = typeof this.inviteRecord.duration !== 'undefined' ? this.inviteRecord.duration : 0
        const driveDuration = moment.duration(duration, 'seconds').humanize()
        return driveDuration
      },
      getAvailabiltyAM: function () {
        var available = typeof this.inviteRecord.available_am !== 'undefined' ? this.inviteRecord.available_am : 0
        if (available === 0) {
          return false
        } else if (available === 1) {
          return true
        }
        return false
      },
      getAvailabiltyPM: function () {
        var available = typeof this.inviteRecord.available_pm !== 'undefined' ? this.inviteRecord.available_pm : 0
        if (available === 0) {
          return false
        } else if (available === 1) {
          return true
        }
        return false
      },
      minDate () {
        try {
          return new Date(this.appointmentOptions[0].date)
        } catch (err) {
          return new Date().subtractDays(10)
        }
      },
      maxDate () {
        try {
          const count = this.appointmentOptions.length
          return new Date(this.appointmentOptions[count - 1].date)
        } catch (err) {
          return new Date().addDays(10)
        }
      },
      apptDate () {
        // eslint-disable-next-line camelcase
        const date_start = moment.utc(this.selectedEvent.date, 'YYYY-MM-DD HH:mm:ss')
        // eslint-disable-next-line camelcase
        const date_string = date_start.format('dddd, MMMM Do YYYY')

        // eslint-disable-next-line camelcase
        return date_string
      },
      scheduledApptDateString () {
        try {
          // eslint-disable-next-line camelcase
          const date_start = moment.utc(this.appointmentRecord.date.date, 'YYYY-MM-DD HH:mm:ss')
          // eslint-disable-next-line camelcase
          const date_string = date_start.format('dddd, MMMM Do YYYY')

          // eslint-disable-next-line camelcase
          return date_string
        } catch (error) {
          console.log(error)
          return ''
        }
      },

    },
    watch: {

    },
    methods: {
      ...mapActions(['getInvite', 'getAppointment', 'getAppointmentOptions', 'verifyInvite', 'acceptAppointmentOption']),

      async availChanged_am (value, event) {
        console.log(value)
        event.stopPropagation()
        if (this.inviteVerified) {
          await this.doVerify()
          this.doGetApptOptions()
        }
      },
      async availChanged_pm (value, event) {
        console.log(value)
        event.stopPropagation()
        if (this.inviteVerified) {
          await this.doVerify()
          this.doGetApptOptions()
        }
      },
      doGetInvite () {
        var payload = { invite: this.apptQS, secret: this.secretQS }
        this.getInvite(payload)
      },
      async doGetAppt () {
        var payload = { invite: this.apptQS, secret: this.secretQS, appt_id: this.inviteRecord.appt_id }
        try {
          // eslint-disable-next-line no-unused-vars
          const { data } = await this.getAppointment(payload)
        } catch (error) {

        }
      },

      doGetApptOptions () {
        var payload = { invite: this.apptQS, secret: this.secretQS }
        this.getAppointmentOptions(payload)
      },
      async doVerify () {
        console.log('doing verify')
        this.warningModal = false
        var payload = {
          invite: this.apptQS,
          secret: this.secretQS,
          available_am: this.inviteRecord.bool_avail_am,
          available_pm: this.inviteRecord.bool_avail_pm,
          customer_notes: this.inviteRecord.customer_notes || '',
        }

        try {
          const verifySuccess = await this.verifyInvite(payload)
          if (verifySuccess) {
            this.activeTab = 1
          } else {
            alert(':( we could not verify your information submitted.')
          }
        } catch (error) {

        }
      },
      async doAcceptOption () {
        console.log('doing accept')
        // this.warningModal = false;
        var payload = {
          invite: this.apptQS,
          secret: this.secretQS,
          option: this.selectedEvent,
        }
        console.log(payload)
        this.processingAppt = true

        try {
          const taskModelAccept = await this.acceptAppointmentOption(payload)
          this.processingAppt = false
          this.confirmSelectionModal = false
          if (taskModelAccept.success) {
            this.successGettingApptModal = true
            this.activeTab = 0
            this.doGetInvite()
          } else {
            this.doGetApptOptions()
            this.errorGettingApptModal = true
          }
          // if(verifySuccess){
          //     this.tabIndex = 1;
          // }
          // else{
          //     alert(':( we could not verify your information submitted.')
          // }
        } catch (error) {

        }
      },
      onEventClick (event, e) {
        this.selectedEvent = event
        console.log(event)
        this.confirmSelectionModal = true

        // Prevent navigating to narrower view (default vue-cal behavior).
        e.stopPropagation()
      },
    },
    mounted () {
      this.doGetInvite()
    },
    components: {
      VueCal,
    },

  }
</script>

<style scoped>

</style>
